// export const APIURL = "http://localhost:34567";
export const APIURL = "https://server.brainstorm.ng/Result-Associate-Backend";
// const APIURL = "https://galaxybis.ebudgetkano.ng/test/result-associate-api";

// export const APIURL = "https://result-associate-89f711bf110c.herokuapp.com";
export async function fetchData(queryTerms = {}) {
  try {
    let qArr = [];
    Object.keys(queryTerms).forEach((a) => {
      if (typeof queryTerms[a] === "object" && queryTerms[a].length > 1) {
        qArr.push(queryTerms[a].map((b) => `${a}=${b}`).join("&"));
      } else {
        qArr.push(`${a}=${queryTerms[a]}`);
      }
    });
    // console.log(qArr);
    let raw = await fetch(`${APIURL}/query-data?${qArr.join("&")}`);
    return raw.json();
  } catch (error) {
    return error;
  }
}

export const _fetchApi = (
  url,
  success = (f) => f,
  error = (f) => f,
  empty = (f) => f
) => {
  const token = localStorage.getItem("@@auth_token");
  fetch(`${APIURL}${url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: token,
    },
  })
    .then((raw) => raw.json())
    .then((result) => {
      if (result) {
        success(result);
      } else {
        empty();
      }
    })
    .catch((err) => {
      error(err);
    });
};
// export const _fetchApi = (
//   url,
//   success = (f) => f,
//   error = (f) => f,
//   empty = (f) => f
// ) => {
//   let actualURL = `${APIURL}${url}`;
//   fetch(actualURL)
//     .then((raw) => raw.json())
//     .then((response) => {
//       if (response) {
//         success(response);
//       } else {
//         console.log("Empty response");
//         empty();
//       }
//     })
//     .catch((err) => {
//       error(err);
//     });
// };

export const get_country_classification = (cb) => {
  _fetchApi(
    `/grouping`,
    (d) => {
      cb(d.results);
      // console.log(d, "llllllll");
    },
    (err) => {
      console.log(err);
    }
  );
};
